<template>
  <div class="step-tab">
    <div class="cp-card">
      <BoxVisibilityToggle
          :boxVisibility="profile.box_visibility"
          boxKey="email_salesman"
          :label="L.sendEmailToSalesman || 'Send email to the salesman'"
          :hint="L.sendEmailToSalesmanHint || 'The salesman stored on the trip also receives the reservation email (at their login email address).'" />

      <div class="cp-grid">
        <CustomInput type="email" :label="L.reservationEmail1 || 'Reservation email recipient 1'" v-model="profile.reservation_email_1" />
        <CustomInput type="email" :label="L.reservationEmail2 || 'Reservation email recipient 2 (optional)'" v-model="profile.reservation_email_2" />
      </div>
      <p class="cp-hint">{{ L.reservationEmailHint || 'All recipients receive the same booking-details email. Leave everything empty (and the salesman toggle off) to send no email.' }}</p>

      <div class="cp-toggle">
        <CustomSwitch v-model="profile.send_pdf_to_buyer" />
        <div>
          <span class="cp-toggle__label">{{ L.sendPdfToBuyer || 'Send reservation-confirmation PDF to the buyer' }}</span>
          <span class="cp-toggle__desc">{{ L.sendPdfToBuyerHint || 'When on, the buyer gets a PDF summary of their reservation attached to the confirmation email.' }}</span>
        </div>
      </div>

      <div class="cp-toggle">
        <CustomSwitch v-model="profile.allow_pdf_download" />
        <div>
          <span class="cp-toggle__label">{{ L.allowPdfDownload || 'Let the buyer download the PDF on completion' }}</span>
          <span class="cp-toggle__desc">{{ L.allowPdfDownloadHint || 'When on, a “Download PDF” button is shown on the confirmation screen after booking.' }}</span>
        </div>
      </div>

    </div>

    <PreviewFrame :label="L.preview || 'Preview'">
      <ConfirmationPreview :sendPdf="!!profile.send_pdf_to_buyer" :lang="lang" :brandColor="brandColor" />
    </PreviewFrame>
  </div>
</template>

<script>
import CustomInput from '../../parts/CustomInput.vue'
import CustomSwitch from '../../parts/CustomSwitch.vue'
import PreviewFrame from './previews/PreviewFrame.vue'
import ConfirmationPreview from './previews/ConfirmationPreview.vue'
import BoxVisibilityToggle from './BoxVisibilityToggle.vue'

/**
 * Confirmation step tab: the salesman-recipient toggle (email_salesman box — the
 * trip's stored salesman gets the reservation email too), the static reservation-
 * email recipients + the PDF toggles (send to buyer / allow download). All
 * profile-level. NOTE: the reservation-email BODY is a BRANDING field (owned by
 * the seller reservation email) — it is NOT edited here.
 */
export default {
  name: 'StepTabConfirmation',
  components: { CustomInput, CustomSwitch, PreviewFrame, ConfirmationPreview, BoxVisibilityToggle },
  props: {
    options: { type: Object, required: true },
    profile: { type: Object, required: true },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  }
};
</script>

<style scoped>
.step-tab { animation: cp-fade .2s ease; }
@keyframes cp-fade { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }

.cp-card { background: #fff; border-radius: 1rem; box-shadow: 0 2px 12px rgba(0,0,0,0.06); padding: 1.5rem 1.75rem; }
.cp-label { display: block; font-size: 0.78rem; font-weight: 600; color: #555; margin-bottom: 0.25rem; }
.cp-input { width: 100%; border: 1px solid #dcdcdc; border-radius: 8px; padding: 0.55rem 0.75rem; font-size: 0.9rem; background: #fafafa; box-sizing: border-box; }
.cp-input:focus-within, .cp-input:focus { outline: none; border-color: #999; background: #fff; }
.cp-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem 1.5rem; }
@media (max-width: 800px) { .cp-grid { grid-template-columns: 1fr; } }
.cp-field { display: flex; flex-direction: column; min-width: 0; }
.cp-hint { font-size: 0.8rem; color: #888; margin: 0.5rem 0 0; max-width: 560px; }

.cp-toggle { display: flex; align-items: flex-start; gap: 1rem; margin-top: 1.25rem; }
.cp-toggle__label { display: block; font-size: 0.95rem; font-weight: 500; color: #2c2c2c; }
.cp-toggle__desc { display: block; font-size: 0.8rem; color: #999; margin-top: 0.15rem; }
</style>
